import React from "react";
import { Box, Typography, TableRow, TableCell } from "@material-ui/core";
import { getFullMonthNameWithYear, currencyFormat } from "@utils/utils";

const FundTable = ({ employeeFundData }) => {
  const totalEmployeeFund = employeeFundData?.reduce(
    (total, item) => total + (item.employeefund || 0),
    0
  );

  return (
    <Box style={rootContainer}>
      <table style={table}>
        <thead style={tableHead}>
          <tr style={tableHeadingRow}>
            <th>Month</th>
            <th style={centerText}>Basic Salary</th>
            <th style={centerText}>Employee Fund</th>
          </tr>
        </thead>
        <tbody>
          {employeeFundData?.map((item, index) => (
            <TableRow key={index} style={tableRow}>
              <TableCell>
                <Typography>
                  {getFullMonthNameWithYear(item?.salary_date)}
                </Typography>
              </TableCell>
              <TableCell style={centerText}>
                <Typography>
                  {currencyFormat(item?.basic_salary, true) || 0}
                </Typography>
              </TableCell>
              <TableCell style={centerText}>
                <Typography>
                  {currencyFormat(item?.employeefund, true) || 0}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell colSpan={2} style={centerText}>
              <Typography variant="h6" style={fundText}>
                {`Total Employee Fund`}
              </Typography>
            </TableCell>
            <TableCell style={centerText}>
              <Typography variant="h6" style={fundText}>
                {currencyFormat(totalEmployeeFund, true)}
              </Typography>
            </TableCell>
          </TableRow>
        </tbody>
      </table>
    </Box>
  );
};

const rootContainer = {
  width: "80%",
  margin: "auto",
  marginTop: "50px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  gap: "3px",
};

const table = {
  width: "90%",
  margin: "auto",
  backgroundColor: "white",
  marginBottom: "12px",
};

const tableHead = {
  fontWeight: "bold",
  backgroundColor: "rgb(58 140 182)",
};

const tableHeadingRow = {
  color: "white",
  padding: "6px 0px",
  fontSize: "20px",
  border: "1px solid gray",
  textTransform: "capitalize",
};

const tableRow = {
  textAlign: "center",
  backgroundColor: "rgb(58 140 182/20%)",
  fontSize: "18px",
};

const centerText = {
  textAlign: "center",
};

const fundText = {
  fontWeight: "bold",
};

export default FundTable;
